import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  createTheme,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
  Typography,
  Snackbar,
  Slide,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { DropzoneArea } from "mui-file-dropzone";

import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import DocumentIcon from "@mui/icons-material/MailLock";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SponsorListTable from "./SponsorTable";
import { themeOptions, theming } from "../../theme";
import { ThemeProvider } from "@emotion/react";
import MainModal from "../MainModal";
import ComponentHeader from "../ComponentHeader";
import excelImg from "../../assets/images/ExcelDownload.svg";
import { useDispatch, useSelector } from "react-redux";

// import {
//   createSponsor,
//   deleteSponsor,
//   editSponsor,
//   getAllSponsor,
// } from "../../stores/actions/sponsor.action";
import {
  createSponsor,
  getSponsors,
  deleteSponsor,
  editSponsor,
} from "../../redux/actions/sponsors-action";
import DownloadFile from "../ExcelExport/DownloadFile";
import CircularProgress from "@mui/material/CircularProgress";
import {
  apiPut,
  fileUpload,
  fileUploadImage,
  uploadImages,
} from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import { BASE_URL } from "../../constant/apiURL";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
    "& * > input": {
      borderRadius: "1px",
      padding: "10px !important",
    },
    "& * > select": {
      padding: "3.5px !important",
    },
  },
  addIconButton: {
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  stack: {
    // border: "1px solid black",
  },
  inputLabel: {
    fontWeight: "bold !important",
    top: "5px",
    color: "black !important",
  },
  button: {
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid #2C633C !important",
    },
  },
  modalDescription: {
    borderTop: "1px solid #cdcdcd !important",
    padding: "15px",
    marginTop: "20px",
    borderBottom: "1px solid #cdcdcd !important",
  },
}));

const initialState = {
  name: "",
  company: "",
  title: "",
  status: "active",
};

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export default function SponsorList(props) {
  const classes = useStyles();
  const theme = createTheme(themeOptions);

  //   Old states
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [alertMessage, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [deleteVisible, setdeleteVisible] = useState(false);
  const [editVisible, seteditVisible] = useState(false);
  const [edit, setedit] = useState(false);
  const [selectedrows, setselectedrows] = useState([]);
  const [clearRow, setclearRow] = useState(false);
  const [numberOfRows, setNumberOfRows] = useState(10);

  const [state, setState] = useState(initialState);
  const [submit, setSubmit] = useState(false);

  const [addSponsor, setAddSponsor] = useState({
    name: "",
    company: "",
    title: "",
    status: "",
    website: "",
    chapter: "",
    imageFiles: "",
  });

  const [selectedRow, setSelectedRow] = useState();
  const [addOrEdit, setAddOrEdit] = useState(false);
  const [initialFileImage, setInitialFileImage] = useState();
  const [refresh, setRefresh] = useState(false);

  const [sponsorAlert, setSponsorAlert] = useState({
    status: false,
    statusMsg: "",
  });

  const dispatch = useDispatch();
  const sponsorsData = useSelector(
    (state) => state?.getSponsorReducer?.data?.data
  );
  let sponsors = sponsorsData;
  // console.log("sponsorsData =============> ", sponsorsData);
  const loading = useSelector((state) => state?.sponsorReducer?.isLoading);

  const sponsorsLoading = useSelector((state) => state?.editSponsorReducer);

  // console.log("sponsorsLoading", sponsorsLoading);

  const [searchText, setSearchText] = useState("");

  if (searchText) {
    sponsors = sponsorsData?.filter((val) => {
      if (
        val?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        val?.company?.toLowerCase().includes(searchText.toLowerCase()) ||
        val?.title?.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return val;
      }
    });
  }

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setAddSponsor({
      name: "",
      company: "",
      title: "",
      status: "",
      website: "",
      chapter: "",
      imageFiles: "",
    });
    setOpen(false);
    setState(initialState);
  };

  const onEditPress = () => {
    if (selectedrows?.length == 1) {
      setedit(!edit);
    } else {
      alert("Please Select one item!");
    }
  };

  const onSelectRow = (e) => {
    if (selectedrows?.length != e?.selectedRows?.length) setedit(false);
    setselectedrows(e?.selectedRows);
    setclearRow(false);
  };

  const onChangeValue = (e, name) => {
    setState((prevState) => ({ ...prevState, [name]: e }));
  };

  const clearState = () => {
    setState({ ...initialState });
  };

  const validate = async () => {
    const isEmpty = Object.keys(state).some(function (x) {
      return state[x] === "" || state[x] === null;
    });

    if (isEmpty) {
      setSubmit(true);
      alert("All fields are required");
      return false;
    } else {
      setSubmit(false);
      return true;
    }
  };

  const _handleChangeName = (e) => {
    const { value } = e.target;
    setAddSponsor({ ...addSponsor, name: value });
  };
  const _handleChangeCompany = (e) => {
    const { value } = e.target;
    setAddSponsor({ ...addSponsor, company: value });
  };
  const _handleChangeTitle = (e) => {
    const { value } = e.target;
    setAddSponsor({ ...addSponsor, title: value });
  };
  const _handleChangeStatus = (item) => {
    setAddSponsor({ ...addSponsor, status: item });
  };
  const _handleChangeChapter = (e) => {
    const { value } = e.target;
    setAddSponsor({ ...addSponsor, chapter: value });
  };
  const _handleChangeWebsite = (e) => {
    const { value } = e.target;
    setAddSponsor({ ...addSponsor, website: value });
  };

  const _handleChangeFileImages = (val) => {
    //console.log("val", val[0]?.name);
    // setAddSponsor({ ...addSponsor, imageFiles: val });

    if (val.length >= 0) {
      fileUploadImage(ApiEndpoints.sponsor.addImage, val[0])
        .then((res) => {
          // console.log("res", res);
          setAddSponsor({ ...addSponsor, imageFiles: res?.logo });
        })
        .catch((err) => {
          // console.log("err", err);
        });
    }
  };

  // const initalImage = () => {
  //     if (addSponsor.imageFiles !== "") {
  //       return `${BASE_URL}${addSponsor.imageFiles}`;
  //     } else {
  //       return false;
  //     }
  // };

  const file = new File([""], `${BASE_URL}${addSponsor.imageFiles}`, {
    type: "text/plain",
  });

  // console.log("file======", file);

  const onSubmit = async () => {
    if (addSponsor.name === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Enter Sponsor Name");
      return;
    }
    if (addSponsor.company === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Enter Sponsor Company Name");
      return;
    }
    if (addSponsor.title === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Enter Sponsor Title");
      return;
    }

    let dataObj = {
      name: addSponsor.name,
      company: addSponsor.company,
      title: addSponsor.title,
      status: addSponsor.status,
      website: addSponsor.website,
      logo: addSponsor.imageFiles,
    };

    dispatch(createSponsor(dataObj, refresh, setRefresh));
    setSnackbar(true);
    setAlertType("success");
    setAlertMsg("Sponsor Added Successfully");
    setAddSponsor({
      name: "",
      company: "",
      title: "",
      status: "",
      website: "",
      chapter: "",
      imageFiles: "",
    });
    setOpen(false);
    // dispatch(getSponsors());
    // dispatch(getSponsors());
    // dispatch(getSponsors());
  };

  const openDeleteModal = () => {
    // if (selectedrows?.length == 1) {
    setdeleteVisible(true);
    // } else {
    //   alert("Please Select one item!");
    // }
  };

  const onDelete = () => {
    // const result = await dispatch(deleteSponsor(selectedrows[0]?._id));
    // if (result?.status) {
    //   setdeleteVisible(false);
    //   // dispatch(getSponsors());
    //   setselectedrows([]);
    //   setclearRow(true);
    //   alert(result?.message);
    // } else {
    //   alert(result?.message);
    // }
    dispatch(deleteSponsor(selectedRow?._id));
    setdeleteVisible(false);
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
  };

  const onEdit = () => {
    let dataObj = {
      name: addSponsor.name,
      company: addSponsor.company,
      title: addSponsor.title,
      status: addSponsor.status,
      website: addSponsor.website,
      logo: addSponsor.imageFiles,
    };
    dispatch(editSponsor(selectedRow?._id, dataObj));
    setOpen(false);
    seteditVisible(false);
    setedit(false);
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());

    // const result = await dispatch(
    //   editSponsor(selectedrows[0], selectedrows[0]?._id)
    // );
    // if (result?.status) {
    //   seteditVisible(false);
    //   setedit(false);
    //   setselectedrows();
    //   setclearRow(true);
    //   dispatch(getSponsors());
    //   alert(result?.message);
    // } else {
    //   alert(result?.message);
    // }
  };

  const handleSwitchSponsor = (val, switchval) => {
    // console.log('newsSwitchRow ======> ', val);
    // console.log('switchval ======> ', switchval);

    const newsSwitchPayload = {
      status: switchval,
    };

    apiPut(
      `${ApiEndpoints.sponsor.base}${ApiEndpoints.sponsor.update}${val?._id}`,
      newsSwitchPayload,
      (res) => {
        // console.log("response news switch api ====> ", res);
        if (res.error == false) {
          setSponsorAlert({
            ...sponsorAlert,
            status: true,
            statusMsg: res.message,
          });
          setInterval(() => {
            setSponsorAlert({ status: false });
          }, 3000);
        }
      },
      (err) => {
        // console.log("err", err);
        // setEditNewsError({ showAlert: true, msg: err?.message })
      }
    );
  };

  const onRowChange = (e) => {
    setNumberOfRows(e);
  };

  useEffect(() => {
    dispatch(getSponsors());
  }, [refresh]);

  return (
    <>
      <Snackbar
        open={snackbar}
        onClose={() => setSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={SlideTransition}
        message="I love snacks"
      >
        <Alert
          onClose={() => setSnackbar(false)}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}!
        </Alert>
      </Snackbar>

      <ThemeProvider theme={theme}>
        <Grid container>
          <Grid item xs={12} p={3}>
            <Grid item container>
              <Grid item xs={12}>
                <ComponentHeader
                  headerTitle="Sponsors List"
                  cbOpenModal={() => {
                    openModal();
                    setAddOrEdit(false);
                  }}
                  onSearch={(e) => setSearchText(e)}
                />
              </Grid>
            </Grid>
            <Grid item container>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
                mt={2}
              >
                <Stack direction="row" spacing={1}>
                  {/* <img src={excelImg} alt={"image"} /> */}
                  <div style={{ marginTop: 10 }}></div>
                  {edit && (
                    <Button
                      onClick={() => seteditVisible(true)}
                      variant="contained"
                      size="small"
                    >
                      Save
                    </Button>
                  )}
                </Stack>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                {sponsorAlert.status == true && (
                  <Alert severity="success">{sponsorAlert.statusMsg}</Alert>
                )}
              </Grid>
            </Grid>
            <Grid item container>
              <Grid item xs={12} m={2}>
                {sponsorsData ? (
                  <SponsorListTable
                    clearRow={clearRow}
                    data={sponsors || []}
                    progressPending={loading}
                    progressComponent={<CircularProgress color="success" />}
                    onSelectedRowsChange={onSelectRow}
                    edit={edit}
                    onChangeRowsPerPage={onRowChange}
                    selectedRows={selectedrows}
                    onDelete={onDelete}
                    openDeleteModal={openDeleteModal}
                    setSelectedRow={setSelectedRow}
                    openModal={openModal}
                    setAddSponsor={setAddSponsor}
                    addSponsor={addSponsor}
                    setAddOrEdit={setAddOrEdit}
                    editSponsor={editSponsor}
                    handleSwitchSponsor={(e, sv) => handleSwitchSponsor(e, sv)}
                  />
                ) : (
                  <>
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                  </>
                )}
              </Grid>
            </Grid>

            {/* add sponsor */}

            <MainModal
              show={open}
              closeModal={closeModal}
              modalHeadTitle={addOrEdit ? "Edit Sponsor" : "Create Sponsor"}
              // modalUserInfo={selectedItem}
              btnLeftTitle="Back"
              btnRightTitle="Save"
              cb={closeModal}
              btnCloseModal={() => (addOrEdit ? onEdit() : onSubmit())}
              leftVariant="outlined"
              rightVariant="contained"
              sx={{ display: "none" }}
              width="900px"
            >
              <Grid item container>
                <Grid item xs={12} mb={2}>
                  <Stack spacing={1}>
                    <>
                      <InputLabel shrink className={classes.inputLabel}>
                        Name
                      </InputLabel>
                      <TextField
                        onChange={_handleChangeName}
                        required
                        placeholder="Name"
                        className={classes.outlineInputBorder}
                        fullWidth
                        variant="outlined"
                        error={!state?.name && submit}
                        helperText={
                          !state?.name && submit ? "Name is required" : ""
                        }
                        value={addSponsor.name}
                      />
                    </>
                    <>
                      <InputLabel shrink className={classes.inputLabel}>
                        Company
                      </InputLabel>
                      <TextField
                        value={addSponsor.company}
                        onChange={_handleChangeCompany}
                        placeholder="Company"
                        required
                        className={classes.outlineInputBorder}
                        fullWidth
                        variant="outlined"
                        error={!state?.company && submit}
                        helperText={
                          !state?.company && submit ? "Company is required" : ""
                        }
                      />
                    </>
                    <>
                      <InputLabel shrink className={classes.inputLabel}>
                        Title
                      </InputLabel>
                      <TextField
                        value={addSponsor.title}
                        required
                        onChange={_handleChangeTitle}
                        placeholder="Title"
                        className={classes.outlineInputBorder}
                        fullWidth
                        variant="outlined"
                        error={!state?.title && submit}
                        helperText={
                          !state?.title && submit ? "Title is required" : ""
                        }
                      />
                    </>
                    <>
                      <InputLabel shrink className={classes.inputLabel}>
                        Website
                      </InputLabel>
                      <TextField
                        value={addSponsor.website}
                        onChange={_handleChangeWebsite}
                        required
                        placeholder="www.example.com"
                        className={classes.outlineInputBorder}
                        fullWidth
                        variant="outlined"
                      />
                    </>
                    <>
                      <InputLabel shrink className={classes.inputLabel}>
                        Status
                      </InputLabel>
                      <Select
                        variant="outlined"
                        value={addSponsor?.status}
                        // onChange={_handleExerciseTypeOnChange}
                        className={classes.outlineInputBorder}
                        name="status"
                        fullWidth
                        label="."
                        //   placeholder="Inactive"
                      >
                        {["active", "inactive"].map((item, i) => (
                          <MenuItem
                            key={i}
                            //   defaultValue={addSponsor.status}
                            value={item}
                            onClick={() => _handleChangeStatus(item)}
                          >
                            <Grid container item>
                              <Grid
                                fontStyle={{ textTransform: "capitalize" }}
                                item
                                xs={10}
                              >
                                {item}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        ))}
                      </Select>
                    </>
                    <div>
                      <DropzoneArea
                        dropzoneText="Tap to upload"
                        initialFiles={[addOrEdit && addSponsor.imageFiles !== undefined && file.name,]}
                        showPreviews={false}
                        onChange={(e) => _handleChangeFileImages(e)}
                        filesLimit={1}
                        acceptedFiles={["image/*"]}
                      />
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </MainModal>

            {/* Confirmation delete modal */}

            <MainModal
              show={deleteVisible}
              closeModal={() => setdeleteVisible(false)}
              modalHeadTitle="Delete"
              btnLeftTitle="Ok"
              btnRightTitle="Cancel"
              leftVariant="contained"
              rightVariant="outlined"
              btnCloseModal={() => setdeleteVisible(false)}
              cb={onDelete}
              sx={{ display: "none" }}
              width="500px"
            >
              <Grid item container>
                <Grid item xs={12} mb={2}>
                  <Stack spacing={1}>
                    <div className={classes.modalDescription}>
                      <p> Are you sure, you want to Delete?</p>
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </MainModal>

            {/* confirmation edit modal */}

            <MainModal
              show={editVisible}
              closeModal={() => seteditVisible(false)}
              modalHeadTitle="Save"
              btnLeftTitle="Save"
              btnRightTitle="Cancel"
              btnCloseModal={() => seteditVisible(false)}
              variant="contained"
              sx={{ display: "none" }}
              width="500px"
              cb={onEdit}
            >
              <Grid item container>
                <Grid item xs={12} mb={2}>
                  <Stack spacing={1}>
                    <div className={classes.modalDescription}>
                      <p> Are you sure, you want to Save?</p>
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </MainModal>
          </Grid>
        </Grid>
      </ThemeProvider>
    </>
  );
}
